import { isRequiredText, strMax } from './utils';
export const validateInquiryQuestion = [
    isRequiredText('質問事項を選択してください'),
];
export const validateInquiryContent = [
    isRequiredText('質問や依頼したい内容を入力してください'),
    strMax(5000, '質問や依頼したい内容は5000文字以内で入力してください'),
];
